<div class="login-container">
  <div class="d-flex flex-column align-items-center">
    <div class="d-flex align-items-center login-header">
      <img src="/assets/login-satsang-logo.svg" />
      <span class="satsang-text ms-2">Satsang Communications</span>
    </div>

    <div class="login-card d-flex flex-column mt-5">
      <span class="satsang-text">Fill details below to Log In</span>
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="d-flex flex-column login-field-gap">
          <input type="email" class="login-field" placeholder="Enter Email" formControlName="email" />
          <span class="error-message"
            *ngIf="loginForm.controls['email'].invalid && loginForm.controls['email'].touched">
            Please provide a valid email address
          </span>
        </div>

        <div class="d-flex flex-column login-field-gap position-relative">
          <i class="fa fa-eye icon" (click)="onEyeOpen()" *ngIf="eyeOpen"></i>
          <img src="/assets/eye-open.svg" class="icon" *ngIf="eyeOpen" (click)="onEyeOpen()" />
          <img src="/assets/eye-close.svg" class="icon" *ngIf="!eyeOpen" (click)="onEyeClose()" />
          <input [type]="type" class="login-field" placeholder="Enter Password" formControlName="password" />
          <span class="error-message"
            *ngIf="loginForm.controls['password'].invalid && loginForm.controls['password'].touched">
            Password is required
          </span>
        </div>

        <div class="error-message text-center my-3" *ngIf="loginErrorMessage">
          {{loginErrorMessage}}
        </div>
        <button type="submit" class="btn-disable-signup w-100" [disabled]="loginForm.invalid" *ngIf="loginForm.invalid">
          Enter your details to proceed
          <!-- Sign In <img src="/assets/arrow-right-bold.svg" class="ms-1" *ngIf="!submitting" /> -->
        </button>
        <button type="submit" class="btn-signup w-100" *ngIf="loginForm.valid" [disabled]="submitting">
          Sign In <img src="/assets/arrow-right-bold.svg" class="ms-1" *ngIf="!submitting" />
          <i *ngIf="submitting" class="fas fa-spinner fa-spin ms-1"></i>
        </button>
      </form>
    </div>
    <div class="login-footer">Unable to login ? <a href="#">Forgot Password.</a></div>
    <div class="login-footer" routerLink="/signup">sign up</div>
  </div>
</div>